
import { List, Swipe, SwipeItem } from 'vant';
import { getTime, transform } from '../../../assets/js/xjpublic';
import { errorModal } from '../../../assets/js/xjcommon';
import parkingBanner from "../../../assets/images/img_parking.png"

export default {
  name: 'home',
  components: {
    [List.name]: List,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data() {
    return {
      // photoType: [9, 10],
      photoType: 9,
      photoList: [],
      countNumber: 0,
      // 翻页
      onePageNumber: 30,
      nowPage: 1,
      adList: [],
      // 上拉刷新
      loading: false,
      finished: false,
      // 是否是第一次加载(解决从首页非顶部进入会出发上拉加载的问题,即一次请求两次)
      isFrist: true,
      OriginPhotoList: [],
      bannerHeight: 210,

    }
  },
  methods: {
    // 获取停车报告列表
    initParkingListFn(isFirst) {
      let _this = this;
      if (isFirst) {
        this.$toast.loading({
          overlay: true,
          duration: 0,
          message: '加载中...'
        });
      }
      this.$axios.post('/v3/u/album/listV2', {
        limit: this.onePageNumber,
        type: [9, 10],
        page: this.nowPage,
      })
        .then(function (response) {
          // 加载状态结束
          _this.loading = false;
          _this.isFrist = false;
          if (response.data.ret === 0) {
            let reqData = response.data.data.data;
            if (reqData && reqData.length > 0) {
              let beforePhotoList = _this.photoList;
              _this.countNumber = response.data.data.total;
              // 先异步解析地址,后分组
              // _this.getLocationFn(reqData);
              // _this.getLocationFn2(reqData);
              // 不解析地址,直接分组
              _this.groupPhotoListFn(reqData);
              // _this.photoList = beforePhotoList.concat(_this.groupPhotoListFn(reqData));
            }
            // 判断是否还有数据
            if (_this.onePageNumber > reqData.length) {
              _this.finished = true;
            }
            _this.$toast.clear();
          } else {
            _this.finished = true;
            _this.$toast.clear();
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取相册信息失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.finished = true;
          _this.isFrist = false;
          _this.$toast.clear();
          errorModal(error, 211);
        })
    },
    // 解析地址(方法一：回调处理,由vue的双向绑定处理,等待时间段)
    getLocationFn(data) {
      for (let n = 0; n < data.length; n++) {
        if (!data[n].location) {
          transform.pointToAddress(data[n].pos[0], data[n].pos[1], 1, function (res) {
            data[n].location = res.address || '';
          });
        }
      }
      this.groupPhotoListFn(data);
    },
    // 异步解析地址(方法二：异步处理,等待时间长)
    async getLocationFn2(data) {
      for (let n = 0; n < data.length; n++) {
        if (!data[n].location) {
          let res = await transform.pointToAddress2(data[n].pos[0], data[n].pos[1], 1);
          data[n].location = res.address || '';
        }
      }
      this.groupPhotoListFn(data);
    },
    // 照片数据格式处理以及根据日期分组(groupType参数为分组方法,1为按日期以及地理位置分组,2为只按日期分组)
    groupPhotoListFn(data) {
      // let arr = [];
      // let lastCreateTime = '0000-00-00';
      // for (let i = 0; i < data.length; i++) {
      //   // url格式处理
      //   data[i].url = decodeURIComponent(data[i].url);
      //   data[i].url_thumb = data[i].url_thumb ? decodeURIComponent(data[i].url_thumb) : '';
      //   // 时间格式处理create_time改为优先使用trigger_time
      //   data[i].createTime = getTime.getTimeText(2, data[i].trigger_time || data[i].create_time);
      //   data[i].createTimeAll = getTime.getFormatDate(2, data[i].trigger_time || data[i].create_time);
      //   // 分组开始
      //   let date = new Date(Date.parse(data[i].trigger_time || data[i].create_time));
      //   let Y = date.getFullYear() + '-';
      //   let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      //   let D = date.getDate();
      //   let dataTime = Y + M + D;
      //   if (lastCreateTime === dataTime) { // 同一天
      //     let index = arr.length - 1;
      //     arr[index].rows.push( data[i] );
      //   } else {
      //     let group = {};
      //     group.createTime = getTime.getTimeText(1, data[i].trigger_time || data[i].create_time);
      //     group.rows = [];
      //     group.rows.push(data[i]);
      //     arr.push(group);
      //   }
      //   lastCreateTime = dataTime;
      // }
      // // console.log(arr);
      // // 只按日期分组
      // // 整理位置坐标
      // let pointArray = [];
      // for (let q = 0; q < arr.length; q++) {
      //   pointArray.push([arr[q].rows[0].pos[0], arr[q].rows[0].pos[1]]);
      // }
      // // 判断旧数据的最后一组日期和新数据的第一组日期是否相同
      // let beforePhotoList = this.photoList;
      // let newGroupData = arr;
      // if (beforePhotoList.length > 0 && beforePhotoList[beforePhotoList.length - 1].createTime === newGroupData[0].createTime) {
      //   // 坐标点移动第一个
      //   pointArray.shift();
      //   // 列表数据处理
      //   beforePhotoList[beforePhotoList.length - 1].rows = beforePhotoList[beforePhotoList.length - 1].rows.concat(newGroupData[0].rows);
      //   // 从新数据的第二组数据开始追加到旧数据数据
      //   // 移除新数据的第一组数据
      //   newGroupData.shift();
      //   if (newGroupData && newGroupData.length > 0) {
      //     this.photoList = beforePhotoList.concat(newGroupData);
      //   } else {
      //     this.photoList = beforePhotoList;
      //   }
      // } else {
      //   this.photoList = beforePhotoList.concat(newGroupData);
      // }

      const reqData = data.map(item => {
        return {
          ...item,
          startToEnd: getTime.getFormatDate(2, item.create_time).substring(11),
          createTime: getTime.getFormatDate(1, item.create_time),
          trigger_timeText: getTime.getTimeText(1, item.create_time),
        }
      })
      // 根据时间同一天，同一imei分组
      const sameDay = reqData.reduce((total, item) => {
        const getSameIMEIAndDay = reqData.filter(itm => itm.createTime === item.createTime && itm.imei === item.imei);
        // 同一taskID合并
        const uniqueTaskId = Array.from(new Set(getSameIMEIAndDay.map(sitem => sitem.task_id)));
        const v = uniqueTaskId.map(uitem => getSameIMEIAndDay.find(gitem => gitem.task_id === uitem));
        total.push({
          finishTimeShow: item.createTime,
          imei: item.imei,
          children: v,
        })
        return total;
      }, [])
      const sortData = sameDay.reduce((t, item) => {
        return t.find(i => i.finishTimeShow === item.finishTimeShow && i.imei === item.imei) ? t : t.concat(item)
      }, []);
      // 新数据添加到原数据
      this.photoList = this.photoList.concat(sortData);
      this.OriginPhotoList = reqData;
      // 解析地址
      // this.pointToAdressByGroupFn(pointArray);
      // 返回列表
      // console.log(arr);
      // return arr;
    },
    // 上拉加载
    onLoad() {
      if (this.isFrist) { return }
      this.nowPage = this.nowPage + 1;
      this.initParkingListFn();
    },
    // 查看停停车位置(地图)
    toParkingPositionPageFn(item) {
      if (item.auth_travel_manage === 2) {
        this.$dialog({
          message: '行程管理权限未开启'
        })
      } else {
        this.$router.push('/parkingPosition?task_id=' + item.task_id)
      }

      // if (pos[0] && pos[1]) {
      //   this.$router.push('/parkingPosition?lon=' + pos[0] + '&lat=' + pos[1] + '&time=' + time + '&task_id=' + taskID)
      // } else {
      //   this.$dialog({
      //     message: '该次停车未上传地址信息'
      //   })
      // }
    },
    transformHandle(id, type) {
      transform.regeoAddress(id, type, (res) => {
        if (res.code === 0) {
          this.photoList = this.photoList.map(item => ({ ...item, children: item.children.map(v => ({ ...v, location: id === v._id ? res.address : v.location })) }))
        }
      });
    },
    deleteParkingReport(items) {
      this.$dialog.confirm({
        title: '删除',
        message: '您确定要删除该停车报告吗',
      })
        .then(() => {
          const _ids = this.OriginPhotoList.filter(item => item.task_id === items.task_id).map(item => item._id)
          this.$toast.loading({
            overlay: true,
            duration: 0,
            message: '删除中...'
          });
          this.$axios.post('/v3/u/album/del', {
            _id: _ids,
          }).then((response) => {
            this.$toast.clear()
            if (response.data.ret === 0) {
              this.nowPage = 1;
              this.photoList = [];
              this.initParkingListFn()
            } else {
              this.$dialog({
                message: response.data.msg
              })
            }

          })
        })
        .catch(() => {
          // on cancel
        });
    },
    // 查看停车照片/视频
    toShowMediaPageFn(taskID) {
      this.$router.push('/showMedia?task_id=' + taskID)
    },
    getIndexBannerFn() {
      this.$axios.post('/v3/u/ad/getAdDetail', { customer: this.$store.state.customer, name: 'parkingBanner' })
        .then((response) => {
          if (response.data.ret === 0) {
            if (response.data.data.length) {
              let adList = response.data.data.map(item => ({
                img_url: item.img_url,
                title: item.title,
                url: item.url,
                scheme: item.scheme
              }));
              this.adList = adList;
            } else {
              this.adList = [{
                img_url: parkingBanner,
              }];
            }
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取停车广告图失败（' + response.data.ret + '）'
            })
          }
        })
    }
  },
  created() {
    window.scrollTo(0, 0);
    this.bannerHeight = (document.documentElement.clientWidth || window.screen.width) > 768 ? 768 / 2 : parseInt((document.documentElement.clientWidth || window.screen.width) / 2);
    this.getIndexBannerFn()
    this.initParkingListFn('isFirst');
  }
}
